/* eslint-disable import/no-anonymous-default-export */
export default {
  control: {
    backgroundColor: "#fff",
    fontSize: 16
  },

  "&multiLine": {
    control: {
      fontFamily: "Roboto",
      minHeight: 45,
      fontSize: 12
    },
    highlighter: {
      padding: 5,
      border: "1px solid transparent",
    },
    input: {
      padding: 5,
      border: "1px solid silver",
    }
  },

  suggestions: {
    list: {
      backgroundColor: "white",
      border: "1px solid rgba(0,0,0,0.15)",
      fontSize: 12,
      maxHeight: 150,
      overflow: 'auto'
    },
    item: {
      padding: "5px 10px",
      borderBottom: "1px solid rgba(0,0,0,0.15)",
      "&focused": {
        backgroundColor: "#cee4e5"
      }
    }
  }
};
